(() => {
  if (window.Shopify && window.Shopify.designMode) return;

  const finePointer = window.matchMedia(
    '(hover: hover) and (pointer: fine)'
  );

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  if (!finePointer.matches) return;

  const cursor = document.querySelector(
    '[data-cl-magic-cursor]'
  );

  if (!cursor) return;


  document.body.classList.add(
    'cl-magic-cursor-enabled'
  );


  let targetX = -100;
  let targetY = -100;

  let currentX = -100;
  let currentY = -100;

  let rafId;


  const interactiveSelector = [
    'a',
    'button',
    'summary',
    '[role="button"]',
    '[data-magic-hover]'
  ].join(',');


  const nativeSelector = [
    'input',
    'textarea',
    'select',
    '[contenteditable="true"]'
  ].join(',');


  function render() {
    currentX += (targetX - currentX) * 0.22;
    currentY += (targetY - currentY) * 0.22;

    cursor.style.transform = `
      translate3d(
        ${currentX - 21}px,
        ${currentY - 21}px,
        0
      )
    `;

    rafId = requestAnimationFrame(render);
  }


  function showCursor() {
    cursor.classList.add('is-visible');
  }


  function hideCursor() {
    cursor.classList.remove('is-visible');
  }


  document.addEventListener(
    'pointermove',
    (event) => {
      targetX = event.clientX;
      targetY = event.clientY;

      const nativeZone =
        event.target.closest(nativeSelector);

      if (nativeZone) {
        hideCursor();
      } else {
        showCursor();
      }
    },
    {
      passive: true
    }
  );


  document.addEventListener(
    'pointerover',
    (event) => {
      const interactive =
        event.target.closest(
          interactiveSelector
        );

      if (interactive) {
        cursor.classList.add(
          'is-hovering'
        );
      }
    }
  );


  document.addEventListener(
    'pointerout',
    (event) => {
      const interactive =
        event.target.closest(
          interactiveSelector
        );

      if (interactive) {
        cursor.classList.remove(
          'is-hovering'
        );
      }
    }
  );


  document.addEventListener(
    'pointerdown',
    (event) => {
      const nativeZone =
        event.target.closest(
          nativeSelector
        );

      if (nativeZone) return;

      cursor.classList.add(
        'is-clicking'
      );

      if (!reducedMotion.matches) {
        createSparkles(
          event.clientX,
          event.clientY
        );
      }
    }
  );


  document.addEventListener(
    'pointerup',
    () => {
      cursor.classList.remove(
        'is-clicking'
      );
    }
  );


  document.addEventListener(
    'mouseleave',
    hideCursor
  );


  document.addEventListener(
    'mouseenter',
    showCursor
  );


  function createSparkles(x, y) {
    const directions = [
      [-18, -22],
      [16, -18],
      [23, 3],
      [13, 20],
      [-16, 19],
      [-24, -2]
    ];

    directions.forEach(
      ([dx, dy], index) => {
        const sparkle =
          document.createElement('span');

        sparkle.className =
          'cl-magic-spark';

        sparkle.style.setProperty(
          '--spark-x',
          `${x}px`
        );

        sparkle.style.setProperty(
          '--spark-y',
          `${y}px`
        );

        sparkle.style.setProperty(
          '--spark-dx',
          `${dx}px`
        );

        sparkle.style.setProperty(
          '--spark-dy',
          `${dy}px`
        );

        sparkle.style.animationDelay =
          `${index * 12}ms`;

        document.body.appendChild(
          sparkle
        );

        sparkle.addEventListener(
          'animationend',
          () => {
            sparkle.remove();
          },
          {
            once: true
          }
        );
      }
    );
  }


  rafId =
    requestAnimationFrame(render);


  window.addEventListener(
    'pagehide',
    () => {
      if (rafId) {
        cancelAnimationFrame(
          rafId
        );
      }
    }
  );

})();